export const CURRENCY_SYMBOL = { USD: "$", GBP: "£", EUR: "€", CAD: "C$", MXN: "Mex$", SEK: "kr", AUD: "A$", JPY: "¥", INR: "₹", PLN: "zł" };

export function fmtMoney(value, currency = "USD", compact = false) {
  const sym = CURRENCY_SYMBOL[currency] || "$";
  const n = Number(value || 0);
  if (compact && Math.abs(n) >= 1000) {
    const units = [
      { v: 1e9, s: "B" },
      { v: 1e6, s: "M" },
      { v: 1e3, s: "K" },
    ];
    for (const u of units) {
      if (Math.abs(n) >= u.v) return `${sym}${(n / u.v).toFixed(1)}${u.s}`;
    }
  }
  return `${sym}${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtNum(value, compact = false) {
  const n = Number(value || 0);
  if (compact && Math.abs(n) >= 1000) {
    if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
    if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  }
  return n.toLocaleString();
}

export function fmtMonth(period) {
  if (!period || period.length !== 7) return period;
  const [y, m] = period.split("-");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[parseInt(m, 10) - 1]} ${y.slice(2)}`;
}
